import { Card, Col, Descriptions, Row, Space, Statistic, Table, Tag, Typography } from 'antd'

import productCenter from '../data/productCenter.json'
const { Title } = Typography

const statusColor = (status: string) => status === 'available' ? 'green' : status === 'error' ? 'red' : 'orange'

const mysqlTypes = [
  { name: 'asin', type: 'VARCHAR / TEXT', note: '商品唯一标识，关联 SQLite 快照' },
  { name: 'shop_name / sku / title / brand', type: 'VARCHAR / TEXT', note: '业务文本字段' },
  { name: 'category_name / standard_product_type', type: 'VARCHAR / TEXT', note: '类目与标准商品类型' },
  { name: 'bullet_point / description / main_image', type: 'TEXT', note: 'Listing 内容与主图 URL' },
  { name: 'online_status', type: 'VARCHAR / TEXT', note: 'Active / Inactive 等状态' },
]

const sqliteTypes = [
  { name: 'asin / shop_name / sku', type: 'TEXT', note: '商品与店铺标识' },
  { name: 'shop_id', type: 'INTEGER', note: '店铺 ID' },
  { name: 'snapshot_date / first_sale_date / open_date', type: 'TEXT', note: 'ISO 日期字符串' },
  { name: 'sale_num / day7_sale_num / quantity', type: 'INTEGER / REAL', note: '销量与库存' },
  { name: 'standard_price', type: 'REAL', note: '价格' },
]

const ProductSync = () => (
  <div>
    <Row gutter={[16, 16]} className="mb-4">
      {productCenter.sources.map((s: any) => (
        <Col xs={24} md={8} key={s.id}>
          <Card>
            <Statistic title={s.name} value={s.records} />
            <Space style={{ marginTop: 8 }}>
              <Tag color={statusColor(s.status)}>{s.status}</Tag>
              <span style={{ color: '#666' }}>{s.message}</span>
            </Space>
          </Card>
        </Col>
      ))}
    </Row>

    <Row gutter={[16, 16]}>
      <Col xs={24} lg={12}>
        <Card title="MySQL 商品字段类型">
          <Table
            rowKey="name"
            columns={[{ title: '字段', dataIndex: 'name' }, { title: '类型', dataIndex: 'type' }, { title: '说明', dataIndex: 'note' }]}
            dataSource={mysqlTypes}
            pagination={false}
            size="small"
          />
        </Card>
      </Col>
      <Col xs={24} lg={12}>
        <Card title="SQLite 快照字段类型">
          <Table
            rowKey="name"
            columns={[{ title: '字段', dataIndex: 'name' }, { title: '类型', dataIndex: 'type' }, { title: '说明', dataIndex: 'note' }]}
            dataSource={sqliteTypes}
            pagination={false}
            size="small"
          />
        </Card>
      </Col>
      <Col span={24}>
        <Card title="当前导入快照">
          <Descriptions column={{ xs: 1, md: 2 }}>
            <Descriptions.Item label="数据生成时间">{productCenter.generatedAt}</Descriptions.Item>
            <Descriptions.Item label="商品记录">{productCenter.stats.total}</Descriptions.Item>
            <Descriptions.Item label="分类根目录">{productCenter.stats.categoryCount}</Descriptions.Item>
            <Descriptions.Item label="回退来源">Sellfox 分类计划</Descriptions.Item>
          </Descriptions>
          <div style={{ marginTop: 16 }}>
            <Title level={5}>分类方法分布</Title>
            <Space wrap>
              {Object.entries(productCenter.stats.methodDistribution).map(([k, v]: any) => <Tag key={k} color="blue">{`${k}: ${v}`}</Tag>)}
            </Space>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
)

export default ProductSync

